import type { OrganizationList } from 'models';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { routes } from 'routes/routes';
import type { OrganizationEntityType } from '../models';
import { useGetOrganizationEntityName } from './useGetOrganizationEntityName';

export const useGetOrganizationEntityBreadcrumb = ({
  entityType,
  organization,
}: {
  entityType: OrganizationEntityType;
  organization: OrganizationList;
}) => {
  const { t } = useTranslation();
  const getEntityName = useGetOrganizationEntityName();

  return useMemo(
    () => [
      {
        path: routes.organization.index,
        title: t('Organizations'),
      },
      {
        path: routes.organization.detail(organization.id),
        title: organization.name,
      },
      {
        path: routes.organization.entities(organization.id, entityType),
        title: t(getEntityName({ entityType })),
      },
    ],
    [entityType, getEntityName, organization.id, organization.name, t],
  );
};
